import { useNavigate, Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { FaClipboardList, FaPencilRuler, FaCogs, FaTools, FaCheckCircle } from "react-icons/fa";

export default function Installasi() {
  const navigate = useNavigate();

  return (
    <main className="bg-[#F3F3F3] text-[#0B132A] min-h-screen">
      <div className="w-full bg-white/70 backdrop-blur border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20 h-14 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-sm transition-colors"
            aria-label="Kembali"
          >
            <BsArrowLeft size={16} />
            Kembali
          </button>
          <span className="text-gray-400">/</span>
          <span className="text-sm text-gray-600">Services</span>
          <span className="text-gray-400">/</span>
          <span className="text-sm font-medium">Installasi</span>
        </div>
      </div>

      <section className="py-10 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20">
          <h1
            className="text-2xl md:text-4xl font-semibold leading-tight"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            Installasi Sistem Audiovisual
          </h1>
          <p
            className="mt-4 text-gray-600 max-w-3xl leading-relaxed"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="100"
          >
            Layanan instalasi kami memastikan setiap perangkat audiovisual 
            dipasang sesuai dengan standar industri yang ada dengan hasil yang rapi, aman, 
            dan siap digunakan. Kami berkomitmen menghadirkan 
            sistem yang berfungsi secara optimal dan tahan lama.
          </p>

          <div
            className="mt-8 flex items-center gap-3"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="200"
          >
            <Link
              to="/request"
              className="inline-flex items-center gap-2 rounded-full border border-emerald-600 px-5 py-2.5 text-sm font-medium text-emerald-700 hover:text-white hover:bg-emerald-600 transition-colors"
            >
              Ajukan Installasi
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </Link>
            <a
              href="https://wa.me/6289507085550"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-gray-700 border border-gray-300 hover:bg-gray-100 transition-colors"
            >
              Chat WhatsApp
            </a>
          </div>
        </div>
      </section>

      <section className="pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20">
          <h2
            className="text-2xl md:text-3xl font-semibold mb-8 text-center"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            Proses Installasi
          </h2>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {[
              {
                icon: <FaClipboardList className="text-emerald-600 text-2xl" />,
                title: "1. Survey Lokasi",
                desc: "Analisa kebutuhan dan pengecekan area untuk memastikan solusi tepat.",
              },
              {
                icon: <FaPencilRuler className="text-emerald-600 text-2xl" />,
                title: "2. Desain & Perencanaan",
                desc: "Membuat layout, kabel, dan skema instalasi secara detail.",
              },
              {
                icon: <FaCogs className="text-emerald-600 text-2xl" />,
                title: "3. Persiapan Perangkat",
                desc: "Perakitan dan konfigurasi awal sebelum dipasang di lokasi.",
              },
              {
                icon: <FaTools className="text-emerald-600 text-2xl" />,
                title: "4. Proses Pemasangan",
                desc: "Instalasi perangkat dilakukan oleh teknisi berpengalaman.",
              },
              {
                icon: <FaCheckCircle className="text-emerald-600 text-2xl" />,
                title: "5. Testing & Training",
                desc: "Uji coba sistem serta pelatihan operator.",
              },
            ].map((step, i) => (
              <div
                key={i}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow p-6 flex flex-col gap-3"
                data-aos="fade-up"
                data-aos-duration="650"
                data-aos-delay={i * 120}
              >
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100">
                  {step.icon}
                </div>
                <h3 className="text-lg font-semibold text-[#0B132A]">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20">
          <div className="flex w-full h-72 md:h-96 overflow-hidden rounded-xl shadow-lg">
            {["1.png", "2.png", "3.png", "4.png", "5.png"].map((img, i) => (
              <div
                key={i}
                className="flex-1 transition-[flex] duration-700 ease-in-out md:hover:flex-[2]"
              >
                <img
                  src={`/images/services/install/${img}`}
                  alt={`Dokumentasi instalasi ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-700 ease-in-out md:hover:scale-[1.02]"
                  loading="lazy"
                  decoding="async"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
}
